/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Return_Remaining_AfterInputs */

const vi_sales_return_remaining_after = /** @type {(inputs: Sales_Return_Remaining_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Còn nợ sau khi trả`)
};

/**

* @param {Sales_Return_Remaining_AfterInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sales_return_remaining_after = /** @type {((inputs?: Sales_Return_Remaining_AfterInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Return_Remaining_AfterInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sales_return_remaining_after(inputs)
});